import React, { ReactElement } from 'react';
import { ButtonProps } from 'reakit/ts';
import { Button, Buttons, SnackBarComponent, Text } from './styles';
import { SnackBarButtonProps, SnackBarProps } from './types';

export const SnackBar = ({
  children,
  buttons,
}: SnackBarProps): ReactElement => {
  return (
    <SnackBarComponent>
      <Text>{children}</Text>
      <Buttons>{buttons}</Buttons>
    </SnackBarComponent>
  );
};

export const SnackBarButton = (
  props: SnackBarButtonProps & ButtonProps
): ReactElement => <Button {...props} />;
